module.exports = __webpack_public_path__ + "fonts/FuturaPT-Light.999b370e.woff";